import * as React from 'react';

import {Card} from 'shells/card/card';
import {EmptyStateSmall} from 'shells/empty-states/empty-state-small';
import NutshellLogo from 'shells/logos/nutshell-logo.svg';

import {IntercomLaunchButton} from '../../intercom';

type Props = {
    isParent: boolean;
};

export function SpecializedBillingInfo(props: Props) {
    const {isParent} = props;

    const title = React.useMemo(() => {
        return isParent ? '' : 'Your Nutshell account is being managed by another instance';
    }, [isParent]);

    const subtitle = React.useMemo(() => {
        return isParent ? (
            <div>
                If you’d like to make changes to your account, please contact your Nutshell advisor
                directly or reach out to our
                <IntercomLaunchButton size='big' variant='text-primary' noPadding={true}>
                    support team
                </IntercomLaunchButton>
            </div>
        ) : (
            <div>
                If you’d like to make changes to your account, please reach out to our
                <IntercomLaunchButton size='big' variant='text-primary' noPadding={true}>
                    support team
                </IntercomLaunchButton>{' '}
                for assistance.
            </div>
        );
    }, [isParent]);

    return (
        <div className='mx-16 my-16'>
            <Card hasBorder={true} fitContent={true}>
                <div className='px-16'>
                    <EmptyStateSmall icon={<NutshellLogo />} title={title} subtitle={subtitle} />
                </div>
            </Card>
        </div>
    );
}
